import _styled from "styled-components";
import { useTranslation } from "react-i18next";
import isDefined from "../../../../Core/isDefined";
import * as DTP from "./DateTimePickerStyles";
import { daysInMonth, monthNames } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MonthView = _ref => {
  let {
    year,
    datesObject,
    onSelectMonth,
    onBack
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!datesObject.dates || datesObject.dates.length <= 12) {
    return null;
  }
  return /*#__PURE__*/_jsxs(DTP.Grid, {
    children: [/*#__PURE__*/_jsx(DTP.GridHeading, {
      children: /*#__PURE__*/_jsx(DTP.BackButton, {
        title: t("dateTime.back"),
        onClick: onBack,
        children: year
      })
    }), /*#__PURE__*/_jsx(DTP.GridBody, {
      children: monthNames.map((m, i) => /*#__PURE__*/_jsxs(_StyledDTPGridRow, {
        onClick: () => isDefined(datesObject[i]) && onSelectMonth(i),
        $_css: !isDefined(datesObject[i]) ? ":hover {\n              background: transparent;\n              cursor: default;\n            }" : "",
        children: [/*#__PURE__*/_jsx(DTP.GridLabel, {
          children: m
        }), /*#__PURE__*/_jsx(DTP.GridRowInner, {
          marginRight: "3",
          children: daysInMonth(i + 1, year).map(d => /*#__PURE__*/_jsx(DTP.GridItem, {
            active: isDefined(datesObject[i]) && isDefined(datesObject[i][d + 1])
          }, d))
        })]
      }, m))
    })]
  });
};
var _StyledDTPGridRow = _styled(DTP.GridRow).withConfig({
  displayName: "MonthView___StyledDTPGridRow",
  componentId: "sc-mb0bx7-0"
})(["", ""], p => p.$_css);